import { Actions } from '#base/Canvas/Actions.js';
import { DesignerDispatch } from '#base/Canvas/Dispatch.js';
import RTICLogoIcon from '#base/resources/icons/rtic-logo.svg';
import classnames from 'classnames';
import React, { memo, useContext } from 'react';

export function faceDisplayName(selectedFace: string) {
  if (!selectedFace) return '';

  if (selectedFace === 'logo') return 'FRONT';
  if (selectedFace === 'non-logo') return 'BACK';

  return selectedFace.toUpperCase();
}

const FaceToggle = ({ config, selectedFace, className = '', size }) => {
  // config should be sorted by face name
  const dispatch = useContext(DesignerDispatch);

  if (config && config.length <= 1) return null;

  return (
    <div className={className}>
      <div className='t-mx-auto t-inline-flex t-w-full t-max-w-[310px] t-items-center t-gap-1 t-rounded-xl t-text-center md:t-gap-0 md:t-bg-neutral-100'>
        {config.map((c, i) => {
          return (
            <span
              key={i}
              className={classnames(
                't-inline-flex t-cursor-pointer t-items-center t-justify-center t-gap-1 t-rounded-xl t-border t-border-transparent t-transition',
                {
                  '!t-border-neutrals-light-grey md:t-bg-white md:t-font-bold': c.face === selectedFace,
                  't-h-2 t-w-2 md:t-h-14 md:t-w-[155px] ': size !== 'sm',
                  't-h-2 t-w-2 md:t-h-10 md:t-w-[115px] md:t-text-xs ': size === 'sm',
                }
              )}
              onClick={() => dispatch(Actions.addFace(c))}>
              {(c.face === 'front' || c.face === 'logo') && (
                <img
                  src={RTICLogoIcon}
                  className='t-hidden t-max-h-[22px] t-max-w-[22px] md:t-inline-block'
                />
              )}
              <span className='t-hidden md:t-inline-block'>{faceDisplayName(c.face)}</span>
            </span>
          );
        })}
      </div>
    </div>
  );
};

export default memo(FaceToggle);
